import React from 'react';

const BaseLayout = ({ children, maxWidth = '900px' }) => {
  return (
    <>
      <style>
        {`
          body {
            position: fixed;
            width: 100%;
            height: 100%;
            overflow: hidden;
            margin: 0;
          }

          .page-container {
            display: flex;
            flex-direction: column;
            height: 100vh;
            background: linear-gradient(180deg, #141118 0%, #0A0308 100%);
          }

          .main-content {
            flex: 1;
            overflow-y: auto;
            padding: 20px 0;
            display: flex;
            justify-content: center;
            box-sizing: border-box;
          }
        `}
      </style>

      <div className="page-container">
        <main className="main-content">
          <div style={{ 
            maxWidth: maxWidth,
            width: '100%',
            padding: '32px',
            boxSizing: 'border-box'
          }}>
            {children}
          </div>
        </main>
        {/* <Footer /> */}
      </div>
    </>
  );
};

export default BaseLayout;